import {
	FORMULA_OPERATIONS as FP,
	GeometryTypes,
	IReferenceDimension,
	PathOperationTypes,
	ShapeType,
} from "../widgets/interfaces/model/enumerations/index";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * Cross mark preset definition. Cross is not part of ECMA Office Open XML specs.
 * This shape is created based on round rect definition. Adjust handler for round rect is used as offset for cross.
 */
export const crossmark: IPresetGeometry = {

	ahLst: [
		{ gdRefX: "adj", maxX: 40000, minX: 5000, pos: { x: "x1", y: "t" },
			referenceDimension : IReferenceDimension.SS },
	],

	avList: [
		{ name: "adj", fmla: { operation: FP.LiteralValue, operands: [16667] } },
	],

	gdLst: [
		{ name: "a", fmla: { operation: FP.PinTo, operands: [0, "adj", 50000] } },
		{ name: "z", fmla: { operation: FP.MultiplyDivide, operands: ["ss", "a", 100000] } },
		{ name: "x1", fmla: { operation: FP.AddSubtract, operands: ["l", "z", 0] } },
		{ name: "x2", fmla: { operation: FP.AddSubtract, operands: ["r", 0, "z"] } },
		{ name: "x3", fmla: { operation: FP.AddSubtract, operands: ["hc", 0, "z"] } },
		{ name: "x4", fmla: { operation: FP.AddSubtract, operands: ["hc", "z", 0] } },
		{ name: "y1", fmla: { operation: FP.AddSubtract, operands: ["t", "z", 0] } },
		{ name: "y2", fmla: { operation: FP.AddSubtract, operands: ["b", 0, "z"] } },
		{ name: "y3", fmla: { operation: FP.AddSubtract, operands: ["vc", 0, "z"] } },
		{ name: "y4", fmla: { operation: FP.AddSubtract, operands: ["vc", "z", 0] } },
	],

	pathLst: [{
		operations: [
			{ pt: { x: "l", y: "z" }, type: PathOperationTypes.MOVE_TO },
			{ pt: { x: "x1", y: "t" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "hc", y: "y3" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "x2", y: "t" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "r", y: "y1" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "x4", y: "vc" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "r", y: "y2" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "x2", y: "b" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "hc", y: "y4" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "x1", y: "b" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "l", y: "y2" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "x3", y: "vc" }, type: PathOperationTypes.LINE_TO },
			{ type: PathOperationTypes.CLOSE },
		],
	}],
	presetShape: ShapeType.cross,
	rect: { l: "x3", t: "y3", r: "x4", b: "y4" },
	type: GeometryTypes.PRESET,
};
